import { render, staticRenderFns } from "./SingleLayerElement.vue?vue&type=template&id=22544a17&scoped=true"
import script from "./SingleLayerElement.vue?vue&type=script&lang=ts"
export * from "./SingleLayerElement.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerElement.vue?vue&type=style&index=0&id=22544a17&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22544a17",
  null
  
)

export default component.exports